import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center min-h-screen"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full px-6 py-8"
}
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"18px"}
}, "arrow_back", -1)
const _hoisted_6 = {
  key: 0,
  class: "bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8"
}
const _hoisted_7 = { class: "flex items-center justify-between mb-4" }
const _hoisted_8 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_9 = {
  key: 0,
  class: "text-gray-600 mt-1"
}
const _hoisted_10 = { class: "flex items-center space-x-3" }
const _hoisted_11 = {
  key: 1,
  class: "flex items-center text-green-600"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"20px"}
}, "check_circle", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-sm text-gray-500 mb-4" }
const _hoisted_15 = { class: "w-full bg-gray-200 rounded-full h-2" }
const _hoisted_16 = {
  key: 1,
  class: "bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8"
}
const _hoisted_17 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_18 = { class: "font-medium text-gray-900" }
const _hoisted_19 = { class: "text-sm text-gray-500" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_22 = { class: "text-lg font-semibold mb-4" }
const _hoisted_23 = { class: "font-medium text-gray-900" }
const _hoisted_24 = { class: "text-sm text-gray-500" }
const _hoisted_25 = {
  key: 3,
  class: "text-center py-8 text-gray-500"
}
const _hoisted_26 = {
  key: 4,
  class: "mt-8"
}
const _hoisted_27 = { class: "text-lg font-semibold mb-4 flex items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2 text-gray-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
  })
], -1)
const _hoisted_29 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-4 w-4 text-blue-600",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "grid gap-4"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "flex items-center justify-between" }
const _hoisted_35 = { class: "font-medium text-gray-900" }
const _hoisted_36 = { class: "text-sm text-gray-500" }
const _hoisted_37 = { class: "flex justify-between items-center" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"16px"}
}, "arrow_back", -1)
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"16px"}
}, "arrow_forward", -1)
const _hoisted_41 = {
  key: 3,
  class: "text-center"
}

import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useProgressStore } from "@/stores/progressStore";
import { usePublicCourseStore } from "@/stores/publicCourseStore";
import {
	getNodeChildren,
	getFileNodeUrl,
	downloadFileNodeAsAttachment,
} from "@/api/course_tree";
import type { CourseTreeNode, LessonNode, FileNode } from "@/models/interfaces";
import Spinner from "@/components/ui/Spinner.vue";
import Btn from "@/components/ui/Btn.vue";
import FileViewer from "@/components/file_viewers/FileViewer.vue";
import InlinePublicPdfViewer from "@/components/file_viewers/InlinePublicPdfViewer.vue";
import GamificationRewardToast from "@/components/ui/GamificationRewardToast.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicLessonViewer',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const progressStore = useProgressStore();
const publicCourseStore = usePublicCourseStore();

const lesson = ref<CourseTreeNode | null>(null);
const lessonChildren = ref<CourseTreeNode[]>([]);
const loading = ref(true);
const loadingChildren = ref(false);
const updating = ref(false);
const selectedFileNode = ref<FileNode | null>(null);
const downloading = ref(false);

const selectedFileNodeUrl = computed(() =>
	selectedFileNode.value && publicCourseStore.courseId
		? getFileNodeUrl(String(publicCourseStore.courseId), selectedFileNode.value.id)
		: "",
);

const openFileViewer = (fileNode: FileNode) => {
	selectedFileNode.value = fileNode;
};

const closeFileViewer = () => {
	selectedFileNode.value = null;
};

const downloadSelectedFile = async () => {
	if (!selectedFileNode.value || !publicCourseStore.courseId) return;
	downloading.value = true;
	try {
		await downloadFileNodeAsAttachment(
			String(publicCourseStore.courseId),
			selectedFileNode.value.id,
		);
	} finally {
		downloading.value = false;
	}
};

const slug = route.params.slug as string;
// reactive so the page reloads when navigating between lessons (the component
// is reused across /c/:slug/lesson/:lessonId routes)
const lessonId = computed(() => route.params.lessonId as string);

// Gamification reward toast
const showRewardToast = computed(() => progressStore.showRewardToast);
const pendingGamificationEvents = computed(() => progressStore.pendingGamificationEvents);
const handleRewardDismissed = () => progressStore.clearRewardToast();

// Computed properties using stores
const isCompleted = computed(() => progressStore.isNodeCompleted(lessonId.value));
const navigation = computed(() => progressStore.getLessonNavigation(lessonId.value));
const topicPosition = computed(() =>
	progressStore.getTopicProgressForLesson(lessonId.value),
);
const previousLesson = computed(() => navigation.value.previous);
const nextLesson = computed(() => navigation.value.next);

// Filter file nodes from lesson children
const fileNodes = computed(
	() =>
		lessonChildren.value.filter(child => child.resourcetype === "FileNode") as FileNode[],
);
const pdfFileNodes = computed(() =>
	fileNodes.value.filter(fn => fn.mime_type === "application/pdf"),
);
const nonPdfFileNodes = computed(() =>
	fileNodes.value.filter(fn => fn.mime_type !== "application/pdf"),
);

const fileNodeUrl = (nodeId: string) =>
	getFileNodeUrl(String(publicCourseStore.courseId), nodeId);

const downloadingPdf = ref<Record<string, boolean>>({});

const downloadPdfFile = async (fileNode: FileNode) => {
	if (!publicCourseStore.courseId) return;
	downloadingPdf.value = { ...downloadingPdf.value, [fileNode.id]: true };
	try {
		await downloadFileNodeAsAttachment(String(publicCourseStore.courseId), fileNode.id);
	} finally {
		downloadingPdf.value = { ...downloadingPdf.value, [fileNode.id]: false };
	}
};

const loadLesson = async () => {
	loading.value = true;
	lesson.value = null;
	lessonChildren.value = [];
	try {
		// Load course if not already loaded
		if (!publicCourseStore.courseId) {
			// Load public course data first (this hits /public/courses/{slug}/)
			const courseData = await publicCourseStore.loadPublicCourse(slug);
			// Set the enrolled course to the same data we got from public API
			publicCourseStore.enrolledCourse = courseData.course;
		}

		if (publicCourseStore.courseId) {
			// Load lesson content and initialize progress if not done
			const [lessonData] = await Promise.all([
				publicCourseStore.getLessonById(publicCourseStore.courseId, lessonId.value),
				progressStore.userProgress
					? Promise.resolve()
					: progressStore.initializeProgress(publicCourseStore.courseId),
			]);

			lesson.value = lessonData;

			// Load course content for navigation if not loaded
			if (!progressStore.allLessons.length) {
				const content = await publicCourseStore.loadCourseContent(
					publicCourseStore.courseId,
				);
				progressStore.setCourseContent(content);
			}

			// Load lesson children (file nodes) if this is a lesson node
			if (lesson.value && lesson.value.resourcetype === "LessonNode") {
				loadingChildren.value = true;
				try {
					const childrenResponse = await getNodeChildren(
						publicCourseStore.courseId,
						lessonId.value,
						1, // page number
					);
					lessonChildren.value = childrenResponse.data;
				} catch (childrenErr) {
					console.warn("Failed to load lesson children:", childrenErr);
					// This is not critical, so we don't fail the whole page
				} finally {
					loadingChildren.value = false;
				}
			}
		}
	} catch (err) {
		console.error("Failed to load lesson:", err);
		// TODO: Show error message
	} finally {
		loading.value = false;
	}
};

onMounted(loadLesson);
// reload when navigating between lessons (component is reused across routes)
watch(
	() => route.params.lessonId,
	(newId, oldId) => {
		if (newId && newId !== oldId) loadLesson();
	},
);

const goBack = () => {
	router.push(`/c/${slug}/journey`);
};

const markAsCompleted = async () => {
	if (!lesson.value || !publicCourseStore.courseId) return;

	updating.value = true;
	try {
		const success = await progressStore.markLessonComplete(
			publicCourseStore.courseId,
			lesson.value.id,
		);

		if (success && nextLesson.value) {
			// Auto-navigate to next lesson after a brief delay
			setTimeout(() => {
				navigateToLesson(nextLesson.value!.id);
			}, 1500);
		}
	} catch (err) {
		console.error("Failed to update progress:", err);
		// TODO: Show error message
	} finally {
		updating.value = false;
	}
};

const navigateToLesson = (id: string) => {
	router.push(`/c/${slug}/lesson/${id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Spinner, {
            size: "xl",
            variant: "primary"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Btn, {
              onClick: goBack,
              variant: "ghost",
              size: "sm",
              class: "flex items-center gap-1"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.back_to_journey")), 1)
              ]),
              _: 1
            })
          ]),
          (lesson.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h1", _hoisted_8, _toDisplayString(lesson.value.title), 1),
                    (lesson.value.estimated_duration_minutes)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t("learning_journey.estimated_time")) + ": " + _toDisplayString(lesson.value.estimated_duration_minutes) + " " + _toDisplayString(_ctx.$t("learning_journey.minutes")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (!_unref(isCompleted))
                      ? (_openBlock(), _createBlock(Btn, {
                          key: 0,
                          onClick: markAsCompleted,
                          loading: updating.value,
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("learning_journey.mark_as_complete")), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.lesson_completed")), 1)
                        ]))
                  ])
                ]),
                (_unref(topicPosition).total > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("learning_journey.lesson_of", {
								current: _unref(topicPosition).index + 1,
								total: _unref(topicPosition).total,
							})), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: "bg-blue-600 h-2 rounded-full transition-all duration-300",
                          style: _normalizeStyle({
								width: `${((_unref(topicPosition).index + 1) / _unref(topicPosition).total) * 100}%`,
							})
                        }, null, 4)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (lesson.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (lesson.value.resourcetype === 'FileNode')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (openFileViewer(lesson.value as FileNode))),
                        class: "border border-gray-200 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer flex items-center justify-between"
                      }, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString((lesson.value as FileNode).file?.name || lesson.value.title || "File"), 1),
                        _createElementVNode("span", _hoisted_19, _toDisplayString((lesson.value as FileNode).mime_type || ""), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (lesson.value.body)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "prose prose-lg max-w-none mb-6",
                      innerHTML: lesson.value.body
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true),
                ((lesson.value as any).file?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t("learning_journey.lesson_materials")), 1),
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (openFileViewer(lesson.value as FileNode))),
                        class: "border border-gray-200 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer flex items-center justify-between"
                      }, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString((lesson.value as any).file?.name), 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString((lesson.value as any).mime_type || ""), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
						!lesson.value.body && (!lesson.value.file || !lesson.value.file.name) && _unref(fileNodes).length === 0
					)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("learning_journey.no_lesson_content")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(fileNodes).length > 0 || loadingChildren.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("h3", _hoisted_27, [
                        _hoisted_28,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.lesson_materials")) + " ", 1),
                        (loadingChildren.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pdfFileNodes), (fileNode) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: fileNode.id,
                          class: "mb-6"
                        }, [
                          _createVNode(InlinePublicPdfViewer, {
                            url: fileNodeUrl(fileNode.id),
                            filename: fileNode.file?.name ?? 'Document',
                            "downloading-file": downloadingPdf.value[fileNode.id],
                            onDownload: ($event: any) => (downloadPdfFile(fileNode))
                          }, null, 8, ["url", "filename", "downloading-file", "onDownload"])
                        ]))
                      }), 128)),
                      (_unref(nonPdfFileNodes).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nonPdfFileNodes), (fileNode) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: fileNode.id,
                                onClick: ($event: any) => (openFileViewer(fileNode)),
                                class: "border border-gray-200 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
                              }, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("h4", _hoisted_35, _toDisplayString(fileNode.file?.name || "Untitled File"), 1),
                                  _createElementVNode("span", _hoisted_36, _toDisplayString(fileNode.mime_type || "Unknown type"), 1)
                                ])
                              ], 8, _hoisted_33))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            (_unref(previousLesson))
              ? (_openBlock(), _createBlock(Btn, {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateToLesson(_unref(previousLesson).id))),
                  variant: "secondary",
                  class: "flex items-center gap-1"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.previous_lesson")) + ": " + _toDisplayString(_unref(previousLesson).title), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_39)),
            (_unref(nextLesson))
              ? (_openBlock(), _createBlock(Btn, {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateToLesson(_unref(nextLesson).id))),
                  variant: "primary",
                  class: "flex items-center gap-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("learning_journey.next_lesson")) + ": " + _toDisplayString(_unref(nextLesson).title) + " ", 1),
                    _hoisted_40
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createVNode(Btn, {
                    onClick: goBack,
                    variant: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("learning_journey.back_to_journey")), 1)
                    ]),
                    _: 1
                  })
                ]))
          ])
        ])),
    (selectedFileNode.value)
      ? (_openBlock(), _createBlock(FileViewer, {
          key: 2,
          filename: selectedFileNode.value.file?.name ?? '',
          url: _unref(selectedFileNodeUrl),
          mimeType: selectedFileNode.value.mime_type ?? '',
          id: selectedFileNode.value.id + '-viewer',
          downloading: downloading.value,
          size: selectedFileNode.value.file?.size ?? 0,
          onViewerClose: closeFileViewer,
          onFileDownload: downloadSelectedFile
        }, null, 8, ["filename", "url", "mimeType", "id", "downloading", "size"]))
      : _createCommentVNode("", true),
    _createVNode(GamificationRewardToast, {
      events: _unref(pendingGamificationEvents),
      visible: _unref(showRewardToast),
      onDismissed: handleRewardDismissed
    }, null, 8, ["events", "visible"])
  ]))
}
}

})